import { SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import TransactionReviewApproveDeclineButton from '@/components/transactionReview/TransactionReviewApproveDeclineButton';
import TransactionReviewDetailsInfo from '@/components/transactionReview/TransactionReviewDetailsInfo';
import TransactionReviewDetailsSummary from '@/components/transactionReview/TransactionReviewDetailsSummary';
import { ROUTES } from '@/constants/routes';
import { useGetTransactionReviewDetails } from '@/hooks/requests/useTransactionReview';
import { Card, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

export default function TransactionReviewDetailsPage() {
  const { uuid = '' } = useParams();
  const { transactionReviewDetails, isTransactionReviewDetailsPending } =
    useGetTransactionReviewDetails(uuid);

  if (isTransactionReviewDetailsPending) {
    return (
      <DefaultLayout header="Transaction Review Details">
        <SVLoader />
      </DefaultLayout>
    );
  }

  if (!transactionReviewDetails) {
    return (
      <DefaultLayout header="Transaction Review Details">
        <Card>
          <Typography>
            Something went wrong retreiving the transaction. Our team has been
            notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  const { transactionDetails, reviewSummary } = transactionReviewDetails;
  const title = transactionDetails?.toAccount
    ? `Send Money To ${transactionDetails.toAccount}`
    : transactionDetails.description;
  const isUnderReview = reviewSummary.reviewStatus === 'under review';

  return (
    <DefaultLayout
      header={title}
      buttons={
        isUnderReview
          ? [
              <TransactionReviewApproveDeclineButton
                key="decline"
                transactionReviewUUID={uuid}
                isApprove={false}
              />,
              <TransactionReviewApproveDeclineButton
                key="approve"
                transactionReviewUUID={uuid}
                isApprove
              />,
            ]
          : []
      }
      breadcrumb={[
        { label: 'Transaction Review', href: ROUTES.TRANSACTION_REVIEW },
        { label: title, isActive: true },
      ]}>
      <Stack spacing={2}>
        <TransactionReviewDetailsSummary
          transactionReviewDetails={transactionReviewDetails}
        />
        <TransactionReviewDetailsInfo transactionDetails={transactionDetails} />
      </Stack>
    </DefaultLayout>
  );
}
